export default function scrollHeader() {
  const headerNav = document.getElementById('js-headerNav');
  var headerTop = document.getElementById('js-header__inner');
  const headerHeight = headerNav.clientHeight;

  window.addEventListener('scroll', () => {
    const currentScrollY = window.scrollY;

    if (currentScrollY > headerHeight) {
      headerNav.classList.add('is-scroll');
      headerTop.classList.add('is-scroll');
    } else {
      headerNav.classList.remove('is-scroll');
      headerTop.classList.remove('is-scroll');
    }
  });
}